<template>
<!-- DATATABLE HEADER-->
<v-card tile flat class="hidden-sm-and-down">
    <v-row no-gutters>
        <div v-for="(item, index) in items" :style="{width: item.width}" :key="index" class="pa-2 detail">
            <div :class="{'header-title': true}" :style="{'justify-content': alignValue(item.align)}">
                <span class="text-capitalize px-2">{{ item.text }}</span>
                <!-- <v-icon v-if="verifyEdit(item, index)" small>edit</v-icon> -->
            </div>
        </div>
    </v-row>
</v-card>
<!-- ./ DATATABLE HEADER-->
</template>

<script>
export default {
    name: "IMTableHeaderTranslation",
    props: {
        items: Array,
        edit_languages: {
            type: Array,
            default: []
        }
    },

    methods: {
        editLanguage(item, index) {
            this.$emit("clickEdit", this.items[index]);
            this.items[index].edit = !item.edit;
        },
        verifyEdit(item, index) {
            if(index > 0 && this.edit_languages.includes(item.text)) {
                return true
            } else {
                return false
            }
        },
        alignValue(value) {
            switch (value) {
            case 'left':
                return 'flex-start';
            case 'center':
                return 'center';
            case 'right':
                return 'flex-end';
            default:
                return 'left';
            }
        },
    }
}
</script>

<style scoped>
.pointer {
    cursor: pointer;
}

.header-title {
    display: flex;
    width: 100%;
}
</style>
